import sortBy from 'lowscore/sortBy.js'
import sum from 'root-core/utils/array/sum.js'

export const aggregateFullPayment = booking => {
  var otherPayments = booking.paymentSchedule.filter(
    payment => payment.paymentType !== 'Deposit'
  )

  if (otherPayments.length) {
    return {
      amount: booking.totalPrice,
      dueDate: sortBy(otherPayments, 'paymentDueDate')[0].paymentDueDate,
    }
  }
}

export const aggregateDeposit = paymentSchedule => {
  let depositPayments = paymentSchedule.filter(
    payment => payment.paymentType === 'Deposit'
  )
  let firstDeposit = sortBy(depositPayments, 'paymentDueDate')[0]

  if (firstDeposit) {
    return {
      dueDate: firstDeposit.paymentDueDate,
      amount: sum(depositPayments.map(d => d.paymentAmount)),
    }
  }
}
